import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, ReportIdSchema, RevisionIdSchema } from "../primitives/ids.js";
import { QualityGateStatusSchema } from "./quality-gate-result.js";
import { ReportCheckDispositionSchema, ReportCheckSummaryV1Schema, ReportCoverageSummaryV1Schema, } from "./report-check-summary.js";
import { ReportLifecycleStatusSchema, ReportTypeSchema } from "./report-lifecycle.js";
/** InternalReportViewV1 — Studio / agency route DTO (no raw QA blob). */
export const InternalReportViewV1Schema = z
    .object({
    schemaVersion: z.literal("internal-report-view.v1.0"),
    reportId: ReportIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    reportType: ReportTypeSchema,
    lifecycleStatus: ReportLifecycleStatusSchema,
    businessGraphRevisionId: RevisionIdSchema,
    artifactSetHash: z.string().min(1),
    qaStatus: QualityGateStatusSchema,
    headline: z.string().min(1),
    staleBanner: z.string().min(1).nullable(),
    coverage: ReportCoverageSummaryV1Schema,
    checks: z.array(ReportCheckSummaryV1Schema),
    generatedAt: z.string().datetime(),
    clientSafe: z.literal(false),
})
    .strict();
export const ClientSafeReportCheckV1Schema = z
    .object({
    areaLabel: z.string().min(1),
    disposition: ReportCheckDispositionSchema,
    clientSafeMessage: z.string().min(1).optional(),
})
    .strict();
/** ClientSafeReportViewV1 — portal whitelist; no tenant IDs or raw check IDs. */
export const ClientSafeReportViewV1Schema = z
    .object({
    schemaVersion: z.literal("client-safe-report-view.v1.0"),
    publicReportRef: ReportIdSchema,
    reportTypeLabel: z.string().min(1),
    lifecycleStatus: z.enum(["READY_CLIENT_SAFE"]),
    headline: z.string().min(1),
    staleBanner: z.string().min(1).nullable(),
    coverage: ReportCoverageSummaryV1Schema,
    checks: z.array(ClientSafeReportCheckV1Schema),
    whatWeDoNotPromise: z.array(z.string().min(1)).min(1),
    generatedAt: z.string().datetime(),
    clientSafe: z.literal(true),
})
    .strict();
//# sourceMappingURL=report-views.js.map